import React from 'react';
import './ui.scss';

export const Checkbox = ({ label, id, className = '', ...props }) => (
  <label className={`builder-ui-checkbox ${className}`} htmlFor={id}>
    <input type="checkbox" id={id} {...props} />
    {label && <span>{label}</span>}
  </label>
);

export default Checkbox;
